export const configuracionColumnasSaldosPorVencer = [
    {
        name: "fecha",
        field: "fecha",
        label: "Fecha",
        align: "left",
    },
    {
        name: "institucion_financiera",
        field: "institucion_financiera",
        label: "Institución financiera",
        align: "left",
    },
    {
        name: "total_por_vencer",
        field: "total_por_vencer",
        label: "Total por vencer",
        align: "left",
    },
    {
        name: "por_vencer_1_30_dias",
        field: "por_vencer_1_30_dias",
        label: "Por vencer 1 a 30 días",
        align: "left",
    },
    {
        name: "por_vencer_1_3_meses",
        field: "por_vencer_1_3_meses",
        label: "Por vencer 1 - 3 meses",
        align: "left",
    },
    {
        name: "por_vencer_3_6_meses",
        field: "por_vencer_3_6_meses",
        label: "Por vencer 3 - 6 meses",
        align: "left",
    },
    {
        name: "por_vencer_6_12_meses",
        field: "por_vencer_6_12_meses",
        label: "Por vencer 6 - 12 meses",
        align: "left",
    },
    {
        name: "por_vencer_mas_12_meses",
        field: "por_vencer_mas_12_meses",
        label: "Por vencer más 12 meses",
        align: "left",
    },
];
